

















import Vue from 'vue'
import { Item2ColElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'Item2ColEl',

  props: {
    templateItemData: {
      type: Object as () => Item2ColElInterface,
      required: true
    }
  },

  computed: {
    separator (): string {
      if (!Object.prototype.hasOwnProperty.call(this.$props.templateItemData, 'separator')) {
        return ''
      }
      return `height: 1px; background-color: ${this.$props.templateItemData.separator};`
    },
    text1color (): string {
      return `color: ${this.$props.templateItemData.text1color || 'textColor'};`
    },
    text2color (): string {
      return `color: ${this.$props.templateItemData.text2color || 'var(--v-darkGray-base)'};`
    }
  }
})
